// extracted by mini-css-extract-plugin
module.exports = {"itemBox":"card-icon_itemBox_870yQ","iconBack":"card-icon_iconBack_IbIk1","icon":"card-icon_icon_2lnLl","author":"card-icon_author_1x2UQ","title":"card-icon_title_290nU"};